/* Model */
class AccountTypeModel extends App.Models.BaseModel {
    modelUrl = 'AccountType';
}
App.Models.AccountType = AccountTypeModel;

/* Collection */
class AccountTypeCollection extends App.Collections.BaseCollection {
    url = 'AccountType';
    model = App.Models.AccountType;
}
App.Collections.AccountTypes = AccountTypeCollection;

/* Router */
class AccountTypeRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'AccountType';
        const model = App.Models.AccountType;
        const collectionClass = App.Collections.AccountTypes;

        super(entityName, model, collectionClass);
    }
}

App.Routers.AccountType = AccountTypeRouter;